<template>
  <button class="my-button" :disabled="isButtonDisabled" @click="startCountdown">
    <span v-if="buttonText">Обработка... {{ buttonText }}</span>
    <slot name="default" v-else></slot>
  </button>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'my-button',
  props:['countdown'],
  setup(props){
    const isButtonDisabled = ref(false)
    const countdown = ref(props.countdown)
    const countdownInterval = ref(null)
    const buttonText = ref('')

    const stopCountdown = ()=>{
      clearInterval(countdownInterval.value);
      isButtonDisabled.value = false;
      buttonText.value = '';
      countdown.value = props.countdown;
    }

    const startCountdown = ()=> {
      isButtonDisabled.value = true;
      buttonText.value = `${countdown.value} сек`;
      countdownInterval.value = setInterval(() => {
        if (countdown.value > 1) {
          countdown.value--;
          buttonText.value = `${countdown.value} сек`;
        } else {
          stopCountdown();
        }
      }, 1000);
    }


    return {
      isButtonDisabled,
      countdown,
      countdownInterval,
      buttonText,
      startCountdown
    }

  }
};
</script>

<style scoped>
.my-button {
  min-width: 178px;
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  background-color: #007BFF;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.my-button:hover {
  background-color: #0056b3;
}
</style>
